export default {
  FEATURED_SLIDER: 'componentFeaturedSlider',
  PAGE_ABOUT_RPA: 'pageAboutRpa',
  PAGE_PRODUCT: 'pageProduct',
  PAGE_SOLUTIONS: 'pageSolutions',
  PAGE_NEWSROOM_ARTICLE: 'pageNewsroomArticle',
  PAGE_RESOURCE: 'pageResource',
  PAGE_RESOURCE_DEMO: 'pageResourceDemo',
  PAGE_WEBINAR_RECORDING: 'pageWebinarRecording',
  PAGE_WHITEPAPER: 'pageWhitePaper',
  PAGE_ANALYST_REPORT: 'pageAnalystReport',
  PAGE_PLACEHOLDER: 'pagePlaceholder',
  PAGE_EVENTS: 'pageEvents',
  PAGE_BROCHURE: 'pageBrochure',
  PAGE_FLEX: 'pageFlex',
  PAGE_FORM_FLEX: 'pageFormFlex',
  PAGE_BLOG_POST: 'pageBlogPost',
  PAGE_SECONDARY_BLOG_POST: 'pageSecondaryBlogPost',
  PAGE_MAIN_BLOG: 'pageMainBlog',
  PAGE_BLOG_AUTHOR_LISTING: 'pageBlogAuthorListing',
  PAGE_BLOG_CATEGORY_LISTING: 'pageBlogCategoryListing',
  PAGE_BLOG_COLLECTION_LISTING: 'pageBlogCollectionListing',
  PAGE_RAW_HTML: 'pageRawHtml',
  HOMEPAGE: 'homepage',
  PAGE_PDF: 'wrapperPdf',
  PAGE_PARTNER_POST: 'pagePartner',
  PAGE_TECHNOLOGY_ALLIANCES: 'pageTechnologyAlliances',
  PAGE_BUSINESS_PARTNERS: 'pageBusinessPartners',
  PAGE_PUBLIC_SECTOR_PARTNERS: 'pagePublicSectorPartners',
  PAGE_CAREER: 'pageCareer',
  PAGE_DOWNLOAD: 'pageDownload',
  PAGE_THANK_YOU: 'pageThankYou',
  PAGE_LEGAL: 'pageLegal',
  BLOG_FEATURED_RESOURCE: 'componentBlogFeaturedResource',
  SUBSCRIBE: 'componentSubscribe',
  PAGE_COMPANY_LISTING: 'pageCompanyListing',
  PAGE_RESOURCE_LISTING: 'pageResourceListing',
  ANNOUNCEMENT: 'componentAnnouncement',
  TAB_ORDER: 'componentTabOrder',
  MICROCOPY_SET: 'microcopySet',
  TEASER: 'teaser',
  NAV_MENU: 'navMenu',
  MAIN_NAV_BANNER: 'componentMainNavBanner',
}
